import { apolloPlugin } from "./apollo";
import { caslPlugin } from "./casl";
import { launchdarklyPlugin } from "./launchdarkly";


export default [apolloPlugin, caslPlugin, launchdarklyPlugin];
